<template>
  <div>
    <BlocoFormularioCadastro voltar="/usuario/bloqueio" @salvar="salvar()">
      <template #form>
        <div
          :class="{
            'panel-primary': !v$.bloqueio.$error,
            'panel-danger': v$.bloqueio.$error,
          }"
          class="panel"
        >
          <div class="panel-heading"> Bloqueio </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <BuscarSelecionarUsuario
                  :validacao="v$.bloqueio.usuario"
                  label-sup="(1)"
                  @selecionadoUsuario="bloqueio.usuario = $event"
                />
              </div>
              <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <label for="regra">Regra</label>
                  <select
                    v-model="bloqueio.regra"
                    data-test-id="select-bloqueio-regra"
                    class="form-control"
                  >
                    <option value="1">Apenas um dia</option>
                    <option value="2">Intervalo de datas</option>
                  </select>
                </div>
              </div>
              <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
                <SelecionarData
                  id="dataInicio"
                  :validacao="v$.bloqueio.dataInicio"
                  label-sup="(1)"
                  @atualizar="bloqueio.dataInicio = $event"
                />
              </div>
              <div
                v-if="bloqueio.regra === '2'"
                class="col-xs-6 col-sm-2 col-md-2 col-lg-2"
              >
                <SelecionarData
                  id="dataFim"
                  :validacao="v$.bloqueio.dataFim"
                  label="Termina em"
                  @atualizar="bloqueio.dataFim = $event"
                />
              </div>
              <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <div class="form-group">
                  <label for="horario">Especificar horário?</label>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <input
                        v-model="bloqueio.temHorario"
                        data-test-id="input-bloqueio-temhorario"
                        type="checkbox"
                        @click="limparHorario()"
                      />
                    </span>
                    <input
                      v-mask="'99:99'"
                      data-test-id="input-auto-3"
                      :disabled="!bloqueio.temHorario"
                      :value="bloqueio.horarioInicio"
                      type="text"
                      class="form-control"
                      @input="
                        atualizaHora('horarioInicio', $event.target.value)
                      "
                    />
                    <span class="input-group-addon">até</span>
                    <input
                      v-mask="'99:99'"
                      data-test-id="input-auto-4"
                      :disabled="!bloqueio.temHorario"
                      :value="bloqueio.horarioFim"
                      type="text"
                      class="form-control"
                      @input="atualizaHora('horarioFim', $event.target.value)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                <SelecionarSituacao
                  :mostrar-todos="false"
                  :validacao="v$.bloqueio.ativo"
                  :valor="bloqueio.ativo"
                  label-sup="(1)"
                  @atualizar="bloqueio.ativo = $event"
                />
              </div>
              <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                <div
                  :class="{ 'has-error': v$.bloqueio.motivo.$error }"
                  class="form-group"
                >
                  <label>Motivo <sup>(1)</sup></label>
                  <select
                    v-model="bloqueio.motivo"
                    data-test-id="select-bloqueio-motivo"
                    class="form-control"
                  >
                    <option
                      v-for="motivo in motivos"
                      :key="motivo._id"
                      :value="motivo.valor"
                    >
                      {{ motivo.valor }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div
                  :class="{ 'has-error': v$.bloqueio.observacao.$error }"
                  class="form-group"
                >
                  <label for="observacao">Observação <sup>(2)</sup></label>
                  <textarea
                    id="observacao"
                    v-model="bloqueio.observacao"
                    data-test-id="textarea-observacao"
                    class="form-control"
                    rows="3"
                    @input="v$.bloqueio.observacao.$touch()"
                  />
                  <span v-if="v$.bloqueio.observacao.$dirty">
                    <span
                      v-if="!v$.bloqueio.observacao.required"
                      class="help-block"
                    >
                      Campo obrigatório quando selecionado motivo "Outro".
                    </span>
                    <span
                      v-if="!v$.bloqueio.observacao.maxLength"
                      class="help-block"
                    >
                      Campo deve ter no máximo
                      {{ v$.bloqueio.observacao.$params.maxLength.max }} letras.
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <p>(1) Campos obrigatórios.</p>
            <p>(2) Campo obrigatório quando selecionado motivo "Outro".</p>
          </div>
        </div>
      </template>
    </BlocoFormularioCadastro>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { maxLength, required, requiredIf } from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'

import { useMenu } from '@/composables/useMenu'
import { cadastroMixin } from '@/mixins/CadastroMixin'
import { dominioMixin } from '@/mixins/DominioMixin'
import UsuarioBloqueioServico from '@/servicos/UsuarioBloqueioServico'
moment.locale('pt-br')

export default {
  directives: { mask: AwesomeMask },
  mixins: [cadastroMixin, dominioMixin],
  setup() {
    useMenu(41)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      consulta: 'UsuarioBloqueio',
      entidade: 'bloqueio',
      servico: new UsuarioBloqueioServico(),
      motivos: [],
      bloqueio: {
        usuario: {
          _id: '',
        },
        dataInicio: '',
        dataFim: '',
        horarioInicio: '00:01',
        horarioFim: '23:59',
        motivo: '',
        observacao: '',
        ativo: '',
        regra: 1,
        temHorario: false,
      },
    }
  },
  validations: {
    bloqueio: {
      usuario: { _id: { required } },
      dataInicio: { required },
      motivo: { required },
      ativo: { required },
      observacao: {
        required: requiredIf(function () {
          return this.bloqueio.motivo === 'Outro'
        }),
        maxLength: maxLength(200),
      },
    },
  },
  created() {
    this.recuperarValoresDominio('MotivoBloqueio').then((res) => {
      this.motivos = res.valores
    })
  },
  methods: {
    atualizaHora(hora, value) {
      const h = moment(value, 'HH:mm')

      if (value.length === 5 && h.isValid()) {
        this.bloqueio[hora] = value
      }
    },
    limparHorario() {
      this.bloqueio.horarioInicio = '00:01'
      this.bloqueio.horarioFim = '23:59'
    },
    preSalvar() {
      if (!this.bloqueio.dataFim) {
        this.bloqueio.dataFim = this.bloqueio.dataInicio
      }
    },
  },
}
</script>
